import { useSlotQuery } from 'src/hooks/query/slot/useSlotQuery';

export function useCurrentSlot(): number {
	const { data } = useSlotQuery();
	return data?.currentSlot ?? 0;
}
